export var ON_INIT_ERROR = 'onInitError';
export var SUBSCRIBE_TO_CHANGES_ERROR = 'subscribeToChangesError';
export var GET_API_ERROR = 'getApiError';
export var BRIDGE_ERROR_TYPES = [ON_INIT_ERROR, SUBSCRIBE_TO_CHANGES_ERROR, GET_API_ERROR];